import { Observable } from 'rxjs';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { API_ENDPOINTS } from '../api/api.service';
import { AuthenticationService } from '../permission/authentication.service';
import { LogService } from '../util/log.service';

/**
 * Azokra a route-okra, amik nincsenek benne az "excludeRoutes" array-ban, automatikusan hozzáadja a 'bearer' auth token-t
 *
 * HTTP interceptor leírás:
 * https://medium.com/@swapnil.s.pakolu/angular-interceptors-multiple-interceptors-and-6-code-examples-of-interceptors-59e745b684ec
 */
@Injectable()
export class BearertokenInterceptor implements HttpInterceptor {
  excludeRoutes: Array<string>;

  constructor(
    private readonly authService: AuthenticationService,
    private readonly log: LogService
  ) {
    // ezekre a route-okra NEM kell a bearer token
    this.excludeRoutes = [environment.baseUrl + API_ENDPOINTS.login];
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.shouldBeIntercepted(request.url)) {
      return this.addBearerToken(request, next);
    } else {
      return next.handle(request);
    }
  } // intercept end

  private shouldBeIntercepted(url: string) {
    // Only intercept requests targeting the main API baseUrl
    // Exclude all other APIs (SMS, cleaners staff, i18n files, etc.)
    if (
      url === environment.smsApiUrl ||
      url === environment.cleanerstaffApiUrl ||
      url === environment.cleanerChatApiUrl ||
      url.startsWith('./assets/i18n/') ||
      !url.startsWith(environment.baseUrl)
    ) {
      return false;
    }

    try {
      return !this.excludeRoutes.some((route) => {
        const urlObj = new URL(url);
        const routeObj = new URL(route);
        return urlObj.pathname === routeObj.pathname;
      });
    } catch (e) {
      this.log.error('Error in BearertokenInterceptor.shouldBeIntercepted: ' + url, e);
      return false;
    }
  }

  private addBearerToken(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let userAuthToken = this.authService.getUserToken();
    const authRequest = request.clone({
      setHeaders: {
        Authorization: `Bearer ${userAuthToken}`
      }
    });
    return next.handle(authRequest);
  }
}
